import { Dialog, DialogTitle, DialogContent, Box, Stack, Button, FormControl, InputLabel, OutlinedInput, Select, MenuItem } from "@mui/material";
import { Snapshot } from "@shared/domain/snapshot/snapshot.aggregate";
import { snapshotRepository } from "@shared/domain/snapshot/snapshot.repository";
import { Toast } from "@shared/infrastructure/ui/components/toast/toast";
import { FormEvent, useState } from "react";

export type SnapshotRestoreProps = {
    countryCode: string;
    snapshots: Snapshot[];
    onCancel: () => void;
    onSubmit: () => void;
};

export const SnapshotRestore = (props: SnapshotRestoreProps) => {
    const [snapshotId, setSnapshotId] = useState<number>();
    const [snapshotError, setSnapshotError] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const HandleRestore = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const isSnapshotError = snapshotId === undefined;
        setSnapshotError(isSnapshotError);
        if (isSnapshotError) {
            return;
        }

        setIsBusy(true);
        snapshotRepository
            .restoreSnapshot(props.countryCode, snapshotId)
            .then(() => {
                props.onSubmit();
            })
            .catch(() => {
                setErrorMessage(
                    "An error occurred while restoring the snapshot. Please try again."
                );
            })
            .finally(() => {
                setIsBusy(false);
            });
    };

    const snapshotSelectItems = props.snapshots.map((s) => {
        return (
            <MenuItem value={s.id}>{s.name}</MenuItem>
        );
    });

    return (
        <>
            <Dialog
                open={true}
                onClose={(_event, reason) => {
                    if (reason === "backdropClick") {
                        return;
                    }
                    props.onCancel();
                }}
                disableRestoreFocus>
                <DialogTitle>Restore snapshot</DialogTitle>
                <DialogContent>
                    <Box
                        sx={{ minWidth: 500 }}
                        id="snapshot-restore-form"
                        component="form"
                        onSubmit={HandleRestore}
                        noValidate
                    >
                        <Stack spacing={2} padding={2}>
                            <FormControl sx={{ minWidth: 350 }}>
                                <InputLabel htmlFor="snapshots-select">Select snapshot to restore</InputLabel>
                                <Select
                                    onChange={(e) => setSnapshotId(e.target.value as number)}
                                    error={snapshotError}
                                    input={<OutlinedInput label="Select snapshot to restore" id="snapshots-select" />}
                                >
                                    {snapshotSelectItems}
                                </Select>
                            </FormControl>
                        </Stack>
                        <Stack
                            direction="row-reverse"
                            spacing={2}
                            padding={2}
                        >
                            <Button
                                variant="contained"
                                type="submit"
                                disabled={isBusy}
                            >
                                Restore
                            </Button>
                            <Button
                                variant="outlined"
                                disabled={isBusy}
                                onClick={props.onCancel}
                                autoFocus>
                                Cancel
                            </Button>
                        </Stack>
                    </Box>
                </DialogContent>
            </Dialog>

            {errorMessage && (
                <Toast
                    isError={true}
                    message={errorMessage}
                    onClose={() => setErrorMessage("")}
                ></Toast>
            )}
        </>
    )
};